import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LegendsUIState {
  isCollapsed: boolean;
}

const initialState: LegendsUIState = {
  isCollapsed: false, // Default to expanded
};

const legendsUISlice = createSlice({
  name: 'legendsUI',
  initialState,
  reducers: {
    toggleCollapse: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    setCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isCollapsed = action.payload;
    },
  },
});

export const { toggleCollapse, setCollapsed } = legendsUISlice.actions;
export default legendsUISlice.reducer; 